import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { AssociateService } from 'src/app/modules/offerdb/services/associate.service';
import { AbstractControl, UntypedFormControl, ValidatorFn, Validators } from '@angular/forms';
import { debounceTime, tap, startWith, map } from 'rxjs/operators';
import { ActivityService } from 'src/app/core/services/activity.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';

@Component({
  selector: 'app-maintenance-screen',
  templateUrl: './maintenance-screen.component.html',
  styleUrls: ['./maintenance-screen.component.scss'],
  standalone: false,
})
export class MaintenanceScreenComponent implements OnInit, OnDestroy {
  selected;
  maintenanceTxt: any = '';
  searchCityCtrl = new UntypedFormControl();
  filteredCity: any = [];
  isLoading = false;
  errorMsg: string;
  citycode: any;
  stateCode: any;
  stateCtrl = new UntypedFormControl();
  filteredStates;
  countryCtrl = new UntypedFormControl();
  filteredCountry: any;
  countryCode: any;
  countryList: any = [];
  stateList: any = [];
  educationList: any = [];
  filteredEdu: any;
  eduCtrl = new UntypedFormControl();
  eduVal: any;
  accessCodeList: any[];

  eduTypeId: any;
  isDisabled: boolean = true;
  // eduCtrl = new FormControl('', [
  //   Validators.required,
  //   forbiddenNamesValidator(this.accessCodeList)
  //  ]);

  constructor(
    private associateService: AssociateService,
    private activityService: ActivityService,
    @Inject(NgxUiLoaderService) private ngxLoader: NgxUiLoaderService,
  ) {}

  ngOnInit() {
    //  this.countryCtrl = new FormControl('', [
    //   Validators.required,
    //   this.forbiddenCountryValidator(this.accessCodeList)
    //  ]);

    // this.searchCityCtrl.valueChanges
    //   .pipe(
    //     debounceTime(500),
    //     tap(() => {
    //       // this.errorMsg = "";
    //       this.filteredCity = [];
    //       this.isLoading = true;
    //     }),
    //     switchMap(value => this.associateService.getCities(value)
    //       .pipe(
    //         finalize(() => {
    //           this.isLoading = false
    //         }),
    //       )
    //     )
    //   )
    //   .subscribe(data => {
    //     this.filteredCity = data;
    //     this.searchCityCtrl.setValidators([ Validators.required,this.forbiddencityValidator(this.filteredCity) ]);
    //   });

    this.searchCityCtrl.valueChanges.subscribe((value) => {
      if (value) {
        this.associateService.getCities(value).subscribe((data) => {
          this.filteredCity = data;
          this.searchCityCtrl.setValidators([Validators.required, this.forbiddencityValidator(this.filteredCity)]);
        });
      }
    });

    this.associateService.getCountry().subscribe(
      (country) => {
        this.countryList = country;
        this.countryCtrl.setValidators([Validators.required, this.forbiddenCountryValidator(this.countryList)]);
      },
      (_error1) => {
        this.activityService.openSnackBar({ msg: 'Something went wrong', isSuccess: false }, 'danger-snack');
      },
    );

    this.filteredCountry = this.countryCtrl.valueChanges.pipe(
      debounceTime(500),
      tap(() => {
        this.isLoading = true;
      }),
      startWith(''),
      map((countryVal) => this.country_filter(countryVal)),
    );

    this.associateService.getEducationType().subscribe(
      (edu) => {
        this.educationList = edu;
        this.eduCtrl.setValidators([Validators.required, this.forbiddenNamesValidator(this.educationList)]);
      },
      (_error2) => {
        this.activityService.openSnackBar({ msg: 'Something went wrong', isSuccess: false }, 'danger-snack');
      },
    );
    this.filteredEdu = this.eduCtrl.valueChanges.pipe(
      debounceTime(500),
      tap(() => {
        this.isLoading = true;
      }),
      startWith(''),
      map((eduVal) => this.edu_filter(eduVal)),
    );
  }

  forbiddenNamesValidator(Services: any[]): ValidatorFn {
    console.log(this.filteredStates);
    return (control: AbstractControl): { [key: string]: any } | null => {
      const index = Services.findIndex((Service) => {
        return Service.educationTypeName == control.value;
      });
      return index < 0 ? { forbiddenNames: { value: control.value } } : null;
    };
  }

  forbiddencityValidator(Services: any[]): ValidatorFn {
    console.log(this.filteredStates);
    return (control: AbstractControl): { [key: string]: any } | null => {
      const index = Services.findIndex((Service) => {
        return Service.city_state_country == control.value;
      });
      return index < 0 ? { forbiddenNames: { value: control.value } } : null;
    };
  }

  forbiddenCountryValidator(Services: any[]): ValidatorFn {
    console.log(this.filteredStates);
    return (control: AbstractControl): { [key: string]: any } | null => {
      const index = Services.findIndex((Service) => {
        return Service.countryName == control.value;
      });
      return index < 0 ? { forbiddenNames: { value: control.value } } : null;
    };
  }

  private country_filter(value): string[] {
    this.isLoading = false;
    const countryFilter = value.toLowerCase();
    return this.countryList.filter((option1) => option1.countryName.toLowerCase().includes(countryFilter));
  }
  private state_filter(value: string): string[] {
    this.isLoading = false;
    const stateFilter = value ? value.toLowerCase() : '';
    return this.stateList.filter((option2) => option2.value.toLowerCase().includes(stateFilter));
  }
  private edu_filter(value): string[] {
    this.isLoading = false;
    const edufilter = value.toLowerCase();
    return this.educationList.filter((option3) => option3.educationTypeName.toLowerCase().includes(edufilter));
  }

  maintenanceDropdown() {
    this.maintenanceTxt = '';
    this.stateCtrl.setValue('');
    this.countryCtrl.patchValue('');
    this.eduCtrl.patchValue('');
    this.searchCityCtrl.patchValue('');

    // this.stateCtrl.markAsPristine();
    //  this.stateCtrl.markAsUntouched();
    //  this.stateCtrl.updateValueAndValidity();
  }

  resetform(f) {
    f.resetForm();
    // this.yourForm.form.markAsPristine();
    //     this.yourForm.form.markAsUntouched();
    //     this.yourForm.form.updateValueAndValidity();
  }
  onCityChange(cityvalue) {
    this.citycode = cityvalue;
  }
  onStateChange(stateValue) {
    this.stateCode = stateValue;
    this.filteredStates = [];
  }
  onEduChange(event) {
    if (event.isUserInput === true) {
      this.educationList.forEach((edu) => {
        if (edu.educationTypeName == event.source.value) {
          this.eduTypeId = edu.educationTypeId;
        }
      });
    }
  }
  onCountryChange(event) {
    this.stateCtrl.patchValue(null);
    this.stateList = [];
    if (event.isUserInput === true) {
      this.countryList.forEach((country) => {
        if (country.countryName == event.source.value) {
          this.countryCode = country.countryCode;
        }
      });
      this.associateService.getStates(this.countryCode).subscribe(
        (state) => {
          if (state.length !== 0) {
            this.stateList = state;
            this.filteredStates = this.stateList;
            this.isDisabled = false;
            this.stateCtrl.setValidators([Validators.required, this.forbiddenstateValidator(this.stateList)]);
          } else {
            this.isDisabled = true;
            this.stateCtrl.clearValidators();
            this.stateCtrl.updateValueAndValidity();
            this.activityService.openSnackBar({ msg: 'No States Present', isSuccess: false }, 'danger-snack');
          }
        },
        (_error3) => {
          this.isDisabled = true;
          this.activityService.openSnackBar({ msg: 'Something went wrong', isSuccess: false }, 'danger-snack');
        },
      );
      this.stateCtrl.valueChanges.subscribe((stateVal) => {
        this.filteredStates = this.state_filter(stateVal);
      });
    }
  }
  forbiddenstateValidator(Services: any[]): ValidatorFn {
    console.log(this.filteredStates);
    return (control: AbstractControl): { [key: string]: any } | null => {
      const index = Services.findIndex((Service) => {
        return Service.value == control.value;
      });
      return index < 0 ? { forbiddenNames: { value: control.value } } : null;
    };
  }

  ngOnDestroy() {
    this.filteredStates = [];
  }

  SaveMaintenance(f) {
    //console.log(f.form.valid);
    if (this.maintenanceTxt) {
      this.maintenanceTxt = this.maintenanceTxt.trim();
    }

    switch (this.selected as any) {
      case 'InstituteVal':
        if (this.maintenanceTxt && this.citycode && this.searchCityCtrl.status == 'VALID') {
          this.ngxLoader.start();
          const instituteData = {
            instituteName: this.maintenanceTxt,
            cityId: this.citycode,
            countryCode: 'IN',
          };
          this.associateService.postInstitute(instituteData).subscribe(
            (response) => {
              this.ngxLoader.stop();

              const insData = {
                msg: response.message,
                isSuccess: true,
              };
              this.activityService.openSnackBar(insData, 'success-snack');
            },
            (_error4) => {
              this.ngxLoader.stop();
              this.activityService.openSnackBar({ msg: 'Something went wrong', isSuccess: false }, 'danger-snack');
            },
          );
          this.maintenanceTxt = '';
          this.searchCityCtrl.patchValue('');
          f.resetForm();
          this.searchCityCtrl.markAsPristine();
          this.searchCityCtrl.markAsUntouched();
          this.searchCityCtrl.updateValueAndValidity();
        }

        break;
      case 'BoardVal':
        if (this.maintenanceTxt) {
          this.ngxLoader.start();
          const universityData = {
            universityName: this.maintenanceTxt,
            cityId: 1,
          };
          this.associateService.postUniversity(universityData).subscribe(
            (response) => {
              this.ngxLoader.stop();

              const uniData = {
                msg: response.message,
                isSuccess: true,
              };
              this.activityService.openSnackBar(uniData, 'success-snack');
            },
            (_error5) => {
              this.ngxLoader.stop();
              this.activityService.openSnackBar({ msg: 'Something went wrong', isSuccess: false }, 'danger-snack');
            },
          );
          this.maintenanceTxt = '';
          f.resetForm();
        }

        break;
      case 'OrganisationVal':
        if (this.maintenanceTxt) {
          this.ngxLoader.start();
          const organizationData = {
            organizationName: this.maintenanceTxt,
          };
          this.associateService.postOrganization(organizationData).subscribe(
            (response) => {
              this.ngxLoader.stop();
              const orgData = {
                msg: response.message,
                isSuccess: true,
              };
              this.activityService.openSnackBar(orgData, 'success-snack');
            },
            (_error6) => {
              this.ngxLoader.stop();
              this.activityService.openSnackBar({ msg: 'Something went wrong', isSuccess: false }, 'danger-snack');
            },
          );
          this.maintenanceTxt = '';
          f.resetForm();
        }

        break;
      case 'CityVal':
        if (this.maintenanceTxt && this.stateCtrl.status == 'VALID' && this.countryCtrl.status == 'VALID') {
          this.ngxLoader.start();
          const cityData = {
            cityName: this.maintenanceTxt,
            stateCode: this.stateCode ? this.stateCode : '',
            countryCode: this.countryCode,
          };
          this.associateService.postCity(cityData).subscribe(
            (response) => {
              this.ngxLoader.stop();
              const cityDetails = {
                msg: response.message,
                isSuccess: true,
              };
              this.activityService.openSnackBar(cityDetails, 'success-snack');
            },
            (_error7) => {
              this.ngxLoader.stop();
              this.activityService.openSnackBar({ msg: 'Something went wrong', isSuccess: false }, 'danger-snack');
            },
          );
          this.maintenanceTxt = '';
          this.countryCtrl.patchValue('');
          this.stateCtrl.patchValue('');
          f.resetForm();
          this.countryCtrl.markAsPristine();
          this.countryCtrl.markAsUntouched();
          this.countryCtrl.updateValueAndValidity();
          this.stateCtrl.markAsPristine();
          this.stateCtrl.markAsUntouched();
          this.stateCtrl.updateValueAndValidity();
        }
        break;
      case 'DegreeVal':
        if (this.maintenanceTxt && this.eduCtrl.status == 'VALID') {
          console.log(this.eduCtrl.status);
          this.ngxLoader.start();
          const degreeData = {
            degreeName: this.maintenanceTxt,
            educationTypeId: this.eduTypeId,
          };
          this.associateService.postEducation(degreeData).subscribe(
            (response) => {
              this.ngxLoader.stop();
              const degreeValData = {
                msg: response.message,
                isSuccess: true,
              };
              this.activityService.openSnackBar(degreeValData, 'success-snack');
            },
            (_error8) => {
              this.ngxLoader.stop();

              this.activityService.openSnackBar({ msg: 'Something went wrong', isSuccess: false }, 'danger-snack');
            },
          );
          this.maintenanceTxt = '';
          this.eduCtrl.patchValue('');
          f.resetForm();
          this.eduCtrl.markAsPristine();
          this.eduCtrl.markAsUntouched();
          this.eduCtrl.updateValueAndValidity();
        }
        break;
      case 'SpecializationVal':
        if (this.maintenanceTxt) {
          this.ngxLoader.start();
          const specializationData = {
            specializationName: this.maintenanceTxt,
          };
          this.associateService.postSpecialization(specializationData).subscribe(
            (response) => {
              this.ngxLoader.stop();
              const specData = {
                msg: response.message,
                isSuccess: true,
              };
              this.activityService.openSnackBar(specData, 'success-snack');
            },
            (_error9) => {
              this.ngxLoader.stop();
              this.activityService.openSnackBar({ msg: 'Something went wrong', isSuccess: false }, 'danger-snack');
            },
          );
          this.maintenanceTxt = '';
          f.resetForm();
        }
        break;
    }
  }
}
